import React from 'react'
import { combineClasses } from 'utils/combineClasses'

export const Divider: React.FC<{className?: string}> = ({className=""}) => {
  return (
    <div className={combineClasses("h-[1px] w-full border-[#e7e5e5] border-[1px]", className)}/>
  )
}
